var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"product"},[_vm._v("\n  "+_vm._s(_vm.account)+"\n  "),_c('van-button',{staticStyle:{"margin":"100px"},on:{"click":_vm.onPay}},[_vm._v("测试")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }